import { render } from "./ProductCard.vue?vue&type=template&id=b710f4ac&scoped=true&ts=true"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"

import "./ProductCard.vue?vue&type=style&index=0&id=b710f4ac&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b710f4ac"]])

export default __exports__